/**
 * Swiper Initialization Module
 * 
 * @package KateMedia
 */

export function initSwiper() {
    // Swiper должен быть глобально доступен (window.Swiper) к моменту инициализации.
    // Иначе будут повторяющиеся ошибки вида "ReferenceError: Swiper is not defined".
    if (typeof Swiper === 'undefined') return;

    const photoStripElement = document.querySelector('.photo-strip-swiper');
    const serviceOverviewSwipers = document.querySelectorAll('.service-overview-swiper');

    // if (photoStripElement) {
    //     const slides = photoStripElement.querySelectorAll('.swiper-slide');
    //
    //     try {
    //         const photoStripSwiper = new Swiper('.photo-strip-swiper', {
    //             slidesPerView: 'auto',
    //             spaceBetween: 15,
    //             loop: true,
    //             loopedSlides: slides.length,
    //             speed: 10000,
    //             autoplay: {
    //                 delay: 0,
    //             },
    //             breakpoints: {
    //                 768: {
    //                     spaceBetween: 16,
    //                 },
    //                 1024: {
    //                     spaceBetween: 16,
    //                 }
    //             },
    //             grabCursor: false,
    //             allowTouchMove: false,
    //             simulateTouch: false,
    //         });
    //     } catch (error) {
    //         console.error('Error initializing Swiper:', error);
    //     }
    // } else {
    //     if (!window.swiperAttempts) {
    //         window.swiperAttempts = 1;
    //     } else {
    //         window.swiperAttempts++;
    //     }
    //
    //     if (window.swiperAttempts < 5) {
    //         setTimeout(initSwiper, 500);
    //     }
    // }

    if (serviceOverviewSwipers && serviceOverviewSwipers.length) {
        serviceOverviewSwipers.forEach((el, idx) => {
            const slides = el.querySelectorAll('.swiper-slide');
            if (!slides.length) return;
            try {
                const speed = 12000;
                const direction = el.closest('.service__item')?.getAttribute('data-animate') === 'fade-left' ? 1 : -1;
                const swiper = new Swiper(el, {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    loop: true,
                    loopedSlides: slides.length,
                    allowTouchMove: false,
                    simulateTouch: false,
                    grabCursor: false,
                    speed,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                        reverseDirection: direction === -1,
                    },
                });
                swiper.on('init', () => {
                    el.classList.add('service-overview-swiper--inited');
                });
            } catch (e) {
                console.error('Error initializing service-overview swiper:', e);
            }
        });
    }

    initClientsSwiper();
    initTestimonialsSwiper();
}

function initClientsSwiper() {
    const clientsSwiper = document.querySelector('.clients-swiper');
    
    if (!clientsSwiper) {
        return;
    }
    
    const slides = clientsSwiper.querySelectorAll('.swiper-slide');
    
    if (slides.length === 0) {
        return;
    }
    
    try {
        const swiper = new Swiper(clientsSwiper, {
            slidesPerView: 'auto',
            spaceBetween: 40,
            loop: true,
            loopedSlides: slides.length,
            speed: 8000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                pauseOnMouseLeave: false
            },
            allowTouchMove: false,
            grabCursor: false,
            simulateTouch: false,
            navigation: false,
            pagination: false,
            scrollbar: false,
            watchOverflow: false,
            watchSlidesProgress: false,
            watchSlidesVisibility: false,
            preventInteractionOnTransition: true,
            cssMode: false,
            effect: 'slide'
        });
    } catch (error) {
        console.error('Error initializing clients swiper:', error);
    }
}

function initTestimonialsSwiper() {
    const testimonialsSwiper = document.querySelector('.testimonials-swiper');
    
    if (!testimonialsSwiper) {
        return;
    }
    
    const slides = testimonialsSwiper.querySelectorAll('.swiper-slide');
    
    if (slides.length === 0) {
        return;
    }
    
    try {
        const swiper = new Swiper(testimonialsSwiper, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            centeredSlides: false,
            loop: false,
            navigation: {
                nextEl: '.testimonials__nav-btn--next',
                prevEl: '.testimonials__nav-btn--prev',
            }
        });
    } catch (error) {
        console.error('Error initializing testimonials swiper:', error);
    }
}

